export default "__VITE_ASSET__BEED4dzb__"